import $ from 'jquery'

$(document).ready(dhsv_vc_privacy_menu())

function dhsv_vc_privacy_menu() {
  $('.js-mobile-privacy-toggle').on('click', function () {
    $(this).closest('.privacy-menu').find('.privacy-menu__list').slideToggle()
  })
}
